import { render, staticRenderFns } from "./FolderEditForm.vue?vue&type=template&id=fdc527da&"
import script from "./FolderEditForm.vue?vue&type=script&lang=ts&"
export * from "./FolderEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports